import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DomainNotFoundComponent } from './shared/components/domain-not-found/domain-not-found.component';
import { DeviceNotAuthorizedComponent } from './shared/components/device-not-authorized/device-not-authorized.component';
import { DeviceAccessRequestComponent } from './shared/components/device-access-request/device-access-request.component';
import { DeviceAccessRequestGuard } from './shared/auth/device-access-request.guard';
import { UnsubscribeComponent } from './shared/components/unsubscribe/unsubscribe.component';

const routes: Routes = [
  {
    path: 'unsubscribe',
    component: UnsubscribeComponent
  },
  {
    path: 'auth',
    loadChildren: () => import('./authentication/authentication.module').then((m) => m.AuthenticationModule)
  },
  {
    path: 'laboratory',
    loadChildren: () => import('./laboratory/laboratory.module').then((m) => m.LaboratoryModule)
  },
  {
    path: 'manage',
    loadChildren: () => import('./account/account.module').then((m) => m.AccountModule)
  },
  {
    path: 'kiosks',
    loadChildren: () => import('./kiosks/kiosks.module').then((m) => m.KiosksModule)
  },
  {
    path: 'prints',
    loadChildren: () => import('./shared/components/prints/prints/prints.module').then((m) => m.PrintsModule)
  },
  {
    path: '',
    loadChildren: () => import('./practice/practice.module').then((m) => m.PracticeModule)
  },
  {
    path: 'domain-not-found',
    component: DomainNotFoundComponent
  },
  {
    path: 'device-not-authorized',
    component: DeviceNotAuthorizedComponent
  },
  {
    path: 'device-access-request',
    component: DeviceAccessRequestComponent,
    canActivate: [DeviceAccessRequestGuard]
  },
  { path: '', redirectTo: '/dashboard', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
